import React from 'react'
import PropTypes from 'prop-types'

import { PictureWithStructuredData } from '@aok/image'
import { Breadcrumb } from '@aok/navigation'

import ModuleContainer from '../../_layout/Module/ModuleContainer'

import CopyrightLabel from '../../atoms/CopyrightLabel/CopyrightLabel'
import TemplateHeadline from '../TemplateHeadline/TemplateHeadline'
import Spacer from '../../_layout/Spacer'

const ArticleHeader = ({ headline, breadcrumb, image, readingTime, releaseDate, lastUpdated, author, abstract }) => {
  return (
    <div>
      <ModuleContainer>
        <Breadcrumb items={breadcrumb} className="py-24" />
        <Spacer className="h-48 840:h-80" />
        <TemplateHeadline
          subtitle={headline?.subtitle}
          headline={headline}
          readingTime={readingTime}
          releaseDate={releaseDate}
          lastUpdated={lastUpdated}
          author={author}
          abstract={abstract}
        />
      </ModuleContainer>

      <Spacer className="h-40 840:h-48" />

      <div className="relative w-full h-360 600:h-380 840:h-480 1440:w-1440 1440:mx-auto">
        <figure>
          <PictureWithStructuredData
            {...image}
            loading="eager"
            className="
              h-full w-600 600:w-840 840:w-1440
              absolute left-1/2 transform -translate-x-1/2
            "
          />
          <figcaption className="absolute bottom-2 right-2">
            {image?.copyright && <CopyrightLabel variant="white" text={image.copyright} />}
          </figcaption>
        </figure>
      </div>
    </div>
  )
}

ArticleHeader.propTypes = {
  headline: PropTypes.shape({
    text: PropTypes.string,
  }),
  breadcrumb: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  image: PropTypes.shape({
    alt: PropTypes.string,
    copyright: PropTypes.string,
    variants: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        breakpoint: PropTypes.number,
      })
    ),
  }),
  readingTime: PropTypes.string,
  releaseDate: PropTypes.string,
  lastUpdated: PropTypes.string,
  author: PropTypes.shape({
    name: PropTypes.string,
  }),
  abstract: PropTypes.string,
}

export default ArticleHeader
